module.exports = "<div ncy-breadcrumb></div> <h1 translate>News</h1> <news-overview model=vm.newsOverviewModel parent-state=vm.parentState badge-clicked=vm.badgeClicked(categoryId) selected-category=vm.selectedCategory items-per-page-changed=vm.itemsPerPageChanged($event) view-mode=\"r-sm-2-col r-md-3-col r-lg-4-col r-xl-4-col r-xx-4-col\"></news-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/news/main-overview.html
// module id = 611
// module chunks = 0